import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setKycPopoverShow } from '../../store/modals/kycPopover.slice'

export const connectKycPopover = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
    }
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
      setKycPopoverShow,
    }

    return { actions: bindActionCreators(actions, dispatch) }
  }

  return connect(mapStateToProps, mapDispatchToProps)(component)
}
